import { BNBox } from "@bn-monorepo/js-packages";
import { BoxProps, useTheme } from "@mui/material";

interface Props {
  anchorId: string;
  backgroundColor:
    | "default"
    | "blue"
    | "bluegradient"
    | "lightblue1"
    | "lightblue2"
    | "lightblue3"
    | "lightgray1"
    | "lightyellow1"
    | "red"
    | "white"
    | "bodyGray"
    | "transparent";
  noImage: boolean;
  children?: React.ReactNode;
  sx?: BoxProps["sx"];
  overflow?: React.CSSProperties["overflow"];
}

const SectionWrapper: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { anchorId, noImage, children, backgroundColor, sx, overflow = "hidden" } = props;
  const isTransparent = backgroundColor === "transparent";
  return (
    <BNBox
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <BNBox
        component={"section"}
        id={anchorId}
        sx={{
          display: "grid",
          gridTemplateColumns: noImage ? "1fr" : "1fr 1fr",
          overflow,
          m: 2,
          borderRadius: isTransparent ? undefined : `calc(8 * ${theme.vars.shape.borderRadius})`,
          backgroundColor: isTransparent ? undefined : "background.paper",
          width: "100%",
          maxWidth: "120rem",
          [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            gridAutoRows: "min-content",
            m: 2,
            maxWidth: "60rem",
          },
          //font styling moved from scss classes
          // TODO stop using rem
          ".header": {
            fontSize: "1.8rem",
            lineHeight: 1,
            my: 1,
            fontWeight: "normal",
          },
          ".subHeader": {
            fontSize: { xs: "3rem", md: "5rem" },
            lineHeight: 1.1,
            my: 3,
          },
          ".headerH1": {
            fontSize: "3rem",
          },
          ".headerH2": {
            fontSize: { xs: "2.4rem", md: "2.6rem" },
          },
          ".headerH3": {
            fontSize: { xs: "2rem", md: "2.4rem" },
          },
          ".headerH4": {
            fontSize: { xs: "1.6rem", md: "2rem" },
          },
          ".headerH5": {
            fontSize: { xs: "1.6rem", md: "1.8rem" },
          },
          ".headerH6": {
            fontSize: { xs: "1.6rem", md: "1.6rem" },
          },
          ".largeParagraph": {
            fontSize: "1.8rem",
          },
          ".priceExample": {
            fontSize: "1.6rem",
            my: 1,
          },
          ...sx,
        }}
      >
        {children}
      </BNBox>
    </BNBox>
  );
};

export default SectionWrapper;
